import { HttpStatusCode } from 'axios';
import { useMemo } from 'react';
import { useAuthState } from 'state';
import { AttachedDocument } from 'types';
import ApiService from './ApiService';

export type DocumentResponse = {
    data: Blob | object | null;
    status: number;
};

export class DocumentService extends ApiService {

    async getDocument(documentId: string): Promise<DocumentResponse> {
        const response = await this.get(`/api/onbase/documents/${documentId}`,
            { responseType: 'arraybuffer', headers:{ 'Accept': 'application/pdf' }}
        );
        return {
            data: response.data ?? null,
            status: response.status
        };
    }

    async getDocumentByUrl(documentUrl: string): Promise<DocumentResponse> {
        const response = await this.get(documentUrl,
            { responseType: 'blob' }
        );
        return {
            data: response.data ?? null,
            status: response.status
        };
    }

    async getDisputeDocumentsMetadata(disputeNumber: string): Promise<AttachedDocument[]> {
        const { data, status } = await this.get(`/api/disputes/${disputeNumber}/documents`);
        return this.IsSuccessStatusCode(status) ? data : [];
    }
    
    async getDisputeDocument(disputeNumber: string, documentName: string): Promise<DocumentResponse> {
        const encodedDocumentName = encodeURIComponent(documentName);
        const response = await this.get(`/api/disputes/${disputeNumber}/documents/${encodedDocumentName}`,
            {responseType: 'blob' }
        );
        return {
            data: response.data ?? null,
            status: response.status
        };
    }
   
}

export const useDocumentService = () => {
    const auth = useAuthState();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return useMemo(() => new DocumentService(), [auth]);
};